import * as yup from 'yup';

import { validateDate } from 'app/utils/validations';

const terminateEmployeeSchema = yup.object().shape({
  terminationDate: yup
    .string()
    .required('Leave date is mandatory')
    .test('Invalid date', 'Enter a valid date', (value) => !value || validateDate(value)),
});

export default terminateEmployeeSchema;
